// Сервис для загрузки зависимостей карты meteoblue с локальных ресурсов

const MAPBOX_JS_URL = '/assets/libs/mapbox-gl.js';
const MAPBOX_CSS_URL = '/assets/libs/mapbox-gl.css';
const METEOBLUE_PLUGIN_URL = '/assets/libs/meteoblue-maps-plugin.js';

class MeteoblueLoader {
  constructor() {
    this.loadPromise = null;
  }

  async load() {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = (async () => {
      await this.loadCss(MAPBOX_CSS_URL);
      await this.loadScript(MAPBOX_JS_URL);
      await this.loadScript(METEOBLUE_PLUGIN_URL);

      if (!window.mapboxgl) {
        throw new Error('Mapbox GL JS failed to load');
      }

      if (!window.meteoblueMapsPlugin) {
        throw new Error('meteoblue Maps Plugin failed to load');
      }

      return {
        mapboxgl: window.mapboxgl,
        meteoblueMapsPlugin: window.meteoblueMapsPlugin
      };
    })().catch(error => {
      this.loadPromise = null;
      throw error;
    });

    return this.loadPromise;
  }

  loadScript(src, integrity = null, crossOrigin = 'anonymous') {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      if (integrity) {
        script.integrity = integrity;
      }
      if (crossOrigin) {
        script.crossOrigin = crossOrigin;
      }
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  loadCss(href, integrity = null, crossOrigin = 'anonymous') {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`link[href="${href}"]`)) {
        resolve();
        return;
      }

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      if (integrity) {
        link.integrity = integrity;
      }
      if (crossOrigin) {
        link.crossOrigin = crossOrigin;
      }
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }
}

export default new MeteoblueLoader();
